module.exports = __webpack_public_path__ + "static/media/BC_Faqs.e0ae0153.pdf";